import {Component, HostListener, inject, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsDropdownDirective, BsDropdownModule} from "ngx-bootstrap/dropdown";
import {JobStatusService} from "@wms/app/jobs/service/job-status.service";
import {BaseComponent} from "@wms/components";
import moment from "moment/moment";
import {NotificationService} from "@wms/services";

@Component({
  selector: 'wms-job-menu',
  standalone: true,
  imports: [CommonModule, BsDropdownModule],
  templateUrl: './job-menu.component.html',
  styleUrls: ['./job-menu.component.less']
})
export class JobMenuComponent  extends BaseComponent implements  OnInit{
  jobDataCompleted: any = [];
  jobDataLoading: boolean = true;
  jobTimer: any;
  loadJobError: boolean;

  recentJobVisibleCount: any;
  showhintJob: any;
  showJobList: any = {value: false};
  jobLastChecked: any;
  MAX_JOB_RECENT: number;
  jobStatusService: JobStatusService
  teamId: any;
  jobStatusLoadTime: any;
  notificationService: NotificationService

  constructor() {
    super();
    this.jobStatusService = inject(JobStatusService);
    this.notificationService = inject(NotificationService);
    this.eventManager.jobStatusObservable().subscribe((status: any) => {
      this.loadJobStatus(status)
    });
  }



  ngOnInit() {
    this.teamId = this.projectService.getProjectEdnDetails().id;
    this.jobLastChecked = moment();
    this.jobStatusService.showJobError = false;
    this.MAX_JOB_RECENT = this.recentJobVisibleCount = 4;
    this.jobIconClick()
  }

  retryClick() {
    this.showJobList.value = true;
    this.loadJobStatus();
  }

  jobResponseClick(resObj: any, type?: string) {
    if (resObj.failure)
      window.open(resObj.logFile);
    else if (resObj && resObj.outputObject) {
      window.open(resObj.outputObject.value)
    } else {
      this.invalidJobResponseHandler();
    }
  }

  invalidJobResponseHandler() {
    this.notificationService.show('error', this.locale.LABEL_JOBS + ' ' + this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_TITLE);
  }

  jobIconClick(): any {

    this.jobLastChecked = moment();
    this.recentJobVisibleCount = this.MAX_JOB_RECENT;
    this.jobStatusService.showJobError = false;
    if (this.jobStatusService.showJobSuccess && !this.jobStatusService.jobDataInProgress.length) {
      this.jobStatusService.showJobSuccess = false;
    }
    !this.showJobList.value && this.loadJobStatus();
    this.showJobList.value = !this.showJobList.value;
  }

  pollJobStatus() {
    this.jobTimer = setTimeout(() => {
      this.loadJobStatus();
    }, 10000);
  };

  pollJobStatusExpired() {
    return (
      !this.jobStatusLoadTime || this.loadJobError ||
      Date.now() - this.jobStatusLoadTime > 5000
    );
  };


  setJobStatusNotifier() {
    this.jobDataCompleted.forEach((job: any) => {
      if (job.failure) {
        if (this.jobLastChecked.isSameOrBefore(moment(job.endTime))) {
          this.jobStatusService.showJobError = true;
        }
      }
    });
  }


  onMouseEnterJobResultAction(jobId: string) {
    this.showhintJob = jobId
  }

  onMouseLeaveJobResultAction() {
    this.showhintJob = null
  }

  onMoreClick(event: any) {
    event.stopPropagation();
    this.recentJobVisibleCount = this.jobDataCompleted.length;
  }


  loadJobStatus(forceload?: any) {
    // if (!forceload ) return;
    this.loadJobError = false;
    this.jobStatusService.getJobs(null, {projectId: this.teamId}).then((response) => {
      this.jobDataCompleted.length = 0;
      this.jobStatusService.jobDataInProgress.length = 0;
      let jobInprocess = [],
        jobRecent = [];
      if (!response || !Array.isArray(response)) return;
      if (this.jobDataLoading) {
        this.jobDataLoading = false
      }
      ;
      this.jobStatusLoadTime = Date.now();
      response.forEach((job) => {
        let type = job.metadata && job.metadata.exportWebComponentZip ? "EXPORT_WC" : job.type;
        job.typeLabel = this.getJobTypeLabel(type);
        if (job.completed) {
          job.completedTime =
            (job.endTime && moment(job.endTime).fromNow()) ||
            "-";
          this.jobDataCompleted.push(job);
          // this.push(job);

        } else {
          job.style = {width: (job.percentage || 0) + "%"};
          this.jobStatusService.jobDataInProgress.push(job);
          jobInprocess.push(job);
        }
      });
      this.setJobStatusNotifier();
      clearTimeout(this.jobTimer);
      if (this.jobStatusService.jobDataInProgress.length > 0) {
        this.jobStatusService.showJobSuccess = true;
        this.pollJobStatus();
      }
    }, (error) => {
      clearTimeout(this.jobTimer);
      this.loadJobError = true;
      this.jobDataLoading = false;
      this.jobStatusService.jobDataInProgress.length = 0;
      this.jobDataCompleted.length = 0;
    })

  }


  getJobTypeLabel(type: any) {
    if (!type) return '-';
    switch (type) {
      case 'EXPORT_WAR':
        return this.locale.LABEL_WAR_PROJECT;
      case 'EXPORT_WC':
        return this.locale.LABEL_AS_WEB_COMPONENT_PROJECT;
      case 'CORDOVA_ZIP':
        return this.locale.LABEL_ZIP_CORDOVA;
      case 'DEPLOY_APP':
        return this.locale.LABEL_HEADER_DEPLOY;
      case 'MOBILE_BUILD':
        return this.locale.LABEL_MOBILE_BUILD_FOR_ANDROID;
      case 'PHONEGAP_BUILD':
        return this.locale.LABEL_MOBILE_BUILD_SEND_TO_PHONEGAP;
      default:
        return '-'
    }
  }


}
